import { ENDPOINTS } from '../../endpoints';
import { post } from '../../../utils/http/post';

export default async function resendVerificationEmail(email, product) {
  const result = await post(ENDPOINTS.RESEND_VERIFICATION_EMAIL, {
    email: email,
    product: product,
  });

  assertResponseSuccess(result);
}

function assertResponseSuccess(res) {
  if (res.status !== 200) {
    throw new Error(`Server response was ${res.status}, expected status code was 200.`);
  }
}
